import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import { UAParser } from 'ua-parser-js'
import useOutsideClick from './useOutsideClick'
import useDebouncedSearch from './useDebouncedSearch'

import { global } from './constants'
import SearchResults from './SearchResults'

import { algoliasearch } from 'algoliasearch'

import './style.scss'
import useAlgoliaSearch from './useAlgoliaSearch'
import LabelPillComponent from '../ui/LabelPillComponent'

export default function SearchComponent() {
  const [showRecentSearches, setShowRecentSearches] = useState(false)
  const { client } = useAlgoliaSearch()

  const searchFunction = async inputText => {
    const response = await client.searchSingleIndex(
      {
        indexName: global.indexName,
        searchParams: {
          query: inputText,
          ...global.algoliaSettings
        }
      },
      {
        headers: { 'X-Algolia-UserToken': global.userId }
      }
    )
    const { hits, queryID } = response
    return hits.map(hit => {
      hit.queryId = queryID
      return hit
    })
  }

  const { inputText, setInputText, searchResults } = useDebouncedSearch(searchFunction)

  const ref = useRef()

  useOutsideClick(ref, () => {
    setShowRecentSearches(false)
    setInputText('')
  })

  const handleKeyDown = useCallback(e => {
    if (e.key === 'Escape') {
      setInputText('')
    }
  }, [])


  const { device, browser } = UAParser(navigator.userAgent)
  const isApple = device.vendor === 'Apple'
  const isEdge = browser.name === 'Edge'
  const useEdgeShortcut = !isApple && isEdge

  const shortcutText = isApple ? 'Cmd+K' : (useEdgeShortcut ? 'Ctrl+Alt+K' : 'Ctrl+K')

  const globalHandleKeyDown = useCallback(e => {
    if (e.key === 'k') {
      if (isApple && e.metaKey) {
        ref.current.querySelector('input').focus()
      } else if (useEdgeShortcut && e.ctrlKey && e.altKey) {
        ref.current.querySelector('input').focus()
      } else if (!isApple && !useEdgeShortcut && e.ctrlKey) {
        ref.current.querySelector('input').focus()
      }
    }
  })

  useEffect(() => {
    window.addEventListener('keydown', globalHandleKeyDown)
    return () => {
      window.removeEventListener('keydown', globalHandleKeyDown)
    }
  }, [globalHandleKeyDown])

  return (
    <div className="d-flex pe-8 position-relative align-items-center">
      <div className="flex-grow-1" ref={ref} onKeyDown={handleKeyDown}>
        <div>
          <i className='fas fa-search fa-2x'></i>
          <input
            type='text'
            value={inputText}
            onChange={e => setInputText(e.target.value)}
            placeholder='Search by name, phone, email, ID, DOB'
            aria-label='Search'
            className='border-0 ms-3 search-input-component'
            onFocus={() => setShowRecentSearches(true)}
          />
        </div>
        <SearchResults
          inputText={inputText}
          searchResults={searchResults}
          adminSiteIds={JSON.parse(global.adminSiteIds)}
          usesAdvancedSiteManagement={JSON.parse(global.usesAdvancedSiteManagement)}
          showRecentResults={showRecentSearches}
        />
      </div>
      {inputText.length === 0 && (
        <div className="shortcut-label-container">
          <LabelPillComponent text={shortcutText} useRegularFont={true} / >
        </div>
      )}
    </div>
  )
}
